import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {EntityLinkedToAccountWithAuditMetadataConverter} from '../../../../../common/converter/entityLinkedToAccountWithAuditMetadata.converter';
import {AgendaCalendarModel} from '../entity/agendaCalendar.model';
import {Injectable} from '@angular/core';
import {UserSummaryConverter} from '../../../../../account/modules/user/api/converter/userSummary.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {OfficeSummaryConverter} from '../../../../../office/api/model/converter/officeSummary.converter';
import {AgendaCalendarSummaryModel} from "../entity/agendaCalendarSummary.model";
import {PermissionsConverter} from "../../../../../common/converter/permissions.converter";

@Injectable({providedIn: 'root'})
export class AgendaCalendarSummaryConverter extends HttpModelConverter<AgendaCalendarSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter) {
        super();
    }

    protected createInstance(): AgendaCalendarSummaryModel {
        return new AgendaCalendarSummaryModel();
    }

    protected enrichObject(result: AgendaCalendarSummaryModel, src: AgendaCalendarSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);

    }
}
